import {
  SEARCH_ARCHIVED_FS_OBJECTS,
  CLEAR_SEARCH_ARCHIVED_FS_OBJECTS
} from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${SEARCH_ARCHIVED_FS_OBJECTS}_SUCCESS`) {
    return action.payload;
  }
  if (action.type === CLEAR_SEARCH_ARCHIVED_FS_OBJECTS) return [];

  return state;
};
